import type { TimestampInMillis } from './dates';
import type { ESN, UUID } from './identifier';

export const INCIDENTS_REQUEST_AMOUNT = 10;

export enum AlarmTypes {
  INCIDENT = 'incident',
  NOTIFICATION = 'notification',
}

export enum IncidentTypes {
  DEVICE_PLUGGED = 'device_plugged',
  DEVICE_UNPLUGGED = 'device_unplugged',
}

export interface Incident {
  id: UUID;
  fleetId: UUID;
  type: IncidentTypes;
  deviceId: ESN;
  latitude: number;
  longitude: number;
  date: TimestampInMillis;
  licensePlate: string;
  vehicleModel: string | null;
  vehicleBrand: string | null;
  read: boolean;
  driverName?: string;
  info?: string;
}

export type IncidentWithAddress = Incident & { address: string };

export type Alarm = IncidentWithAddress;

export interface IncidentsPayload {
  endTime: TimestampInMillis;
  amount: number;
  startTime?: TimestampInMillis;
}
